import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { usePageBanner } from './hooks/usePageBanner';
import { PageBanner as PageBannerReskin } from './index_new';

export function PageBanner() {
	const { data, actions } = usePageBanner();

	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (!data.banner) return null;

	if (isEnabled) {
		return <PageBannerReskin />;
	}

	return (
		<div className="col-span-full">
			<PageMessage
				id="starter-dashboard-banner"
				data-testid="starter-dashboard-banner"
				role="alert"
				dismissable={data.banner.dismissable}
				primaryAction={data.banner.primaryAction}
				secondaryAction={data.banner.secondaryAction}
				severity={data.banner.severity}
				message={data.banner.message}
				onClose={actions.onDismiss}
				sx={{ position: 'sticky', top: 0, zIndex: 1 }}
			/>
		</div>
	);
}
